import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Phone: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 3H6L6 17H14V3ZM6 1C4.89543 1 4 1.89543 4 3V17C4 18.1046 4.89543 19 6 19H14C15.1046 19 16 18.1046 16 17V3C16 1.89543 15.1046 1 14 1H6Z"
    />
    <circle cx="10" cy="15" r="1" />
  </IconBase>
);
